import {Button, Typography} from '@mui/material';
import {Stack} from '@mui/system';
import {IconIllustration, StyledCard} from 'presentation/components';
import {CancelledContractEnum, DateFormatEnum} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {formatText, getOnlyFirstWord, stringfyDate} from 'presentation/utils';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {CancelledCardProps} from './types';

const {cancelledCard} = translations['pt-br'].privateFlow.home;
const {learnMore} = translations['pt-br'].commons;

function CancelledCard({isResponsibleWithoutBenefits}: CancelledCardProps) {
	const {
		beneficiary: {nmSocialUsuarioC, nmUsuarioC},
	} = useAccountDataStore(store => store.accountData);
	const navigate = useNavigate();
	const {contractCancellationDate} = useContractStatus();
	const formattedDateToString = contractCancellationDate
		? stringfyDate(contractCancellationDate, DateFormatEnum.DATE_FORMAT_8)
		: '';
	const formattedBeneficiary = getOnlyFirstWord(formatText(nmSocialUsuarioC || nmUsuarioC));

	const goToFindOutMorePage = () => {
		navigate(CancelledContractEnum.FIND_OUT_MORE);
	};

	return (
		<StyledCard.Container
			sx={{
				display: 'flex',
				alignItems: 'start',
				gap: '12px',
			}}>
			<Stack flex={1} flexDirection={'row'} alignItems={'start'} gap={'12px'}>
				<Typography variant="body2" component={'span'} color="text.primary">
					{formattedBeneficiary}
					{cancelledCard.line1}
					<b>{formattedDateToString}</b>
					{isResponsibleWithoutBenefits
						? cancelledCard.isResponsibleWithoutBenefitsLine2
						: cancelledCard.line2}
				</Typography>
				<IconIllustration variant="primary" size="small" customIconName="warning" />
			</Stack>

			<Button variant="outlined" size="small" fullWidth onClick={goToFindOutMorePage}>
				{learnMore}
			</Button>
		</StyledCard.Container>
	);
}

export default CancelledCard;
